import {
    createElementVNode as _$ce,
    map as _$ma,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Tip, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-internet'
};
var _$tmp1 = {
    'className': 'k-icon-internet'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$ma(this.get('types'), function($value, $key) {
            return _$cc(Tip, {
                'type': $value,
                'showIcon': true,
                'closable': true,
                'children': $value
            });
        }, $this),
        _$cc(Tip, {
            'type': 'success',
            'showIcon': true,
            'closable': true,
            'children': '\n        这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容，这是一条测试内容。\n    '
        }),
        _$ce(2, 'h3', '自定义Icon', 16),
        _$cc(Tip, {
            'children': '\n        custom Icon\n    ',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['icon'] = function($super) {
                            return (
                                _$cc(Icon, _$tmp0)
                            );
                        }),
                        (__$blocks['icon'] = function($super, data) {
                            var block = $blocks['icon'];
                            var callBlock = function() {
                                return _$blocks['icon'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$ce(2, 'h3', '标题带Icon', 16),
        _$cc(Tip, {
            'type': 'primary',
            'showIcon': true,
            'children': '\n        This is a tip.\n    ',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['title'] = function($super) {
                            return '这是标题';
                        }),
                        (__$blocks['title'] = function($super, data) {
                            var block = $blocks['title'];
                            var callBlock = function() {
                                return _$blocks['title'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$ce(2, 'h3', '标题自定义Icon', 16),
        _$cc(Tip, {
            'type': 'primary',
            'showIcon': true,
            'closable': true,
            'children': '\n        This is a tip.\n    ',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['icon'] = function($super) {
                            return (
                                _$cc(Icon, _$tmp1)
                            );
                        }),
                        (__$blocks['icon'] = function($super, data) {
                            var block = $blocks['icon'];
                            var callBlock = function() {
                                return _$blocks['icon'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['title'] = function($super) {
                            return '这是标题';
                        }),
                        (__$blocks['title'] = function($super, data) {
                            var block = $blocks['title'];
                            var callBlock = function() {
                                return _$blocks['title'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 0);
};